import { useRef, useEffect, useState } from 'react'

import { getCookie, setCookie, removeCookie, CookieOptions } from 'tiny-cookie'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { Tooltip } from '@material-ui/core'

import { externalDeps } from './external-deps'

function convertPictureURLToUrl(pictureURL: string | undefined) {
  if (pictureURL == null || pictureURL === '') {
    return undefined
  }
  if (pictureURL.startsWith('http')) {
    return pictureURL
  }
  if (pictureURL.startsWith('/download')) {
    return `${externalDeps.envs.PRODUCT_APP_URL_API}/fm${pictureURL}`
  }
  return `${externalDeps.envs.PRODUCT_APP_URL_API}/fm/download/${pictureURL}`
}

function signOut() {
  const options: CookieOptions = { secure: true, expires: -1 }
  // when use try to logout at a subdomain,we can get
  // the domain for token from __token_domain
  options.domain = getCookie('__token_domain')!

  setCookie('__Secure-id_token', '', options)
  setCookie('__Secure-access_token', '', options)
  setCookie('__token_domain', '', options)
  removeCookie('organizationId', options)
  removeCookie('workspaceId', options)
  localStorage.setItem('access_token', '')
  localStorage.setItem('oauthRefreshToken', '')
  localStorage.setItem('oauthTokenExpireTime', '')
  localStorage.setItem('oauthTokenRenewTime', '')
  localStorage.setItem('redirectTo', '')

  window.location.href = '/'
}

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      container: {
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
      },
      content: {
        width: '100%',
        height: 'calc(100vh - 54px)',
        marginTop: 54,
      },
      root: {
        flexGrow: 1,
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
      },
      toolBar: {
        width: '100%',
        height: '54px !important',
        minHeight: '54px !important',
        boxSizing: 'border-box',
      },
      logo: {
        width: 28,
      },
      title: {
        color: 'white',
        marginLeft: 10,
        flexGrow: 1,
      },
    }),
  {
    classNamePrefix: 'minimal-app-shell',
  },
)


interface IUserInfo {
  title: string
  fullName: string
  subject: string
  photo?: {
    aPIID?: string
  }
}

export function AppShell() {
  console.log(externalDeps)
  const classes = useStyles()

  const [userInfo, setUserInfo] = useState<IUserInfo | null>(null)
  useEffect(() => {
    externalDeps.axios
      .post<{ data: { me: { userProfile: IUserInfo } } }>(
        `${externalDeps.envs.PRODUCT_APP_URL_PROFILE}/graphql`,
        {
          operationName: '',
          query:
            'query{me{userProfile{\ntitle\nfullName\nsubject\nphoto{aPIID}}}}',
          // 'query{me{userProfile{}}}',
          variables: {},
        },
      )
      .then((res) => {
        setUserInfo(res.data.data.me.userProfile)
      })
  }, [])

  const contentElementRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (contentElementRef.current != null) {
      // we can't use use contentElementRef directly
      // because it's under control of AppShell React instance
      const contentElementRefValue = contentElementRef.current
      const div = document.createElement('div')
      contentElementRefValue.appendChild(div)
      externalDeps.getContentElement(div)

      return () => {
        contentElementRefValue.removeChild(div)
      }
    }
  }, [contentElementRef.current, externalDeps.getContentElement])

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <div style={{
          background: '#1979ff',
          fontFamily: 'roboto',
          color: '#fff',
          width: '100%',
          height: '54px !important',
          minHeight: '54px !important',
          boxSizing: 'border-box',
          float: 'left'
        }}>


          <svg
            style={{
              float: 'left',
              width: '28px',
              margin: '10px',
            }}
            // height="121"
            viewBox="0 0 107 121"
            width="107"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="#fff">
              <path d="m52.54 120.11c-1.75-.23-3.51-.41-5.25-.71-2.24-.39-4.49-.76-6.67-1.36s-4.18-1.42-6.35-2.18l64.55-110.75.25.12-41.37 97.52c2-.32 3.69-.5 5.33-.86 14-3 25.17-15.11 27.38-29.3 1.0107171-6.1710965.3654149-12.4998886-1.87-18.34-.6670727-1.5770327-.6122862-3.3667232.15-4.9 2.2-4.87 4.23-9.82 6.42-15 .45.51.8.87 1.11 1.27 7.510541 9.8385151 11.297379 22.0173265 10.69 34.38-.76 23.34-18.56 44.34-41.54 48.79-2.54.49-5.14.69-7.7 1-.4130368.080706-.8205252.187588-1.22.32z" />
              <path d="m6.72 94.35c1 1.45 2 2.93 3.05 4.34 1.37 1.8 2.74 3.62 4.28 5.29s3.19 3 4.86 4.62l68.54-108.32-.22-.17-67.48 81.66c-.65-1.94-1.26-3.51-1.7-5.12-3.75-13.79 1.81-29.31 13.39-37.81 5.0105303-3.7424946 10.9258357-6.0858391 17.14-6.79 1.7053709-.1305394 3.2669933-1.0046091 4.27-2.39 3.32-4.2 6.78-8.28 10.35-12.61-.66-.16-1.15-.31-1.65-.39-12.1719759-2.1258114-24.7036028.1198221-35.38 6.34-20.36 11.42-30.8 36.89-24.17 59.33.74 2.49 1.76 4.88 2.63 7.32.11808819.403969.21159283.8147215.28 1.23z" />
            </g>
          </svg>

          <div style={{
            fontSize: "18px",
            lineHeight: '54px',
            color: "#fff",
            float: 'left',
          }}>Business Intelligence</div>


          <div style={{
            position: "absolute",
            right: 0,
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}>
            {userInfo != null && (
              <Tooltip style={{ display: "inline-block" }}
                title={userInfo.fullName}>
                {
                  userInfo.photo != null && userInfo.photo.aPIID != null ? (
                    <img
                      style={{
                        width: 40,
                        borderRadius: '50%',
                      }}
                      width={40}
                      alt={userInfo.fullName[0]}
                      src={convertPictureURLToUrl(userInfo.photo.aPIID)}
                    />
                  ) : (
                    <div
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        border: '2px solid #fff',
                        backgroundColor: '#adadad',
                        color: '#fff',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 24,
                        fontFamily: 'Roboto,sans-serif',
                      }}
                    >
                      { userInfo.fullName.slice(0, 1).toUpperCase() }
                    </div>
                  )
                }

              </Tooltip>
            )}
            <div
              style={{
                height: '36px',
                lineHeight: '36px',
                fontSize: '16px',
                color: "inherit",
                fontWeight: 400,
                padding: "0 10px",
                cursor: 'pointer'
              }}
              onClick={signOut}
            >
              Log out
            </div>
          </div>



        </div>
      </div>
      <div ref={contentElementRef}
        style={{
          width: '100%',
          height: 'calc(100vh - 54px)',
          marginTop: 54
        }} />
    </div>
  )
}
